<template>
    <div>
        <div class="card border-primary mb-3" v-if="model">
            <h5 class="card-header text-primary"><i class="fas fa-user-edit mr-2"></i>{{fullName}}</h5>
            <div class="card-body">
                <div class="row">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold" :for="'firstName' + _uid">
                            {{$t('person.firstName')}}
                        </label>
                        <div class="ml-2"
                             :name="'firstName' + _uid"
                             :id="'firstName' + _uid">
                            {{model.person.firstName}}
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold" :for="'surName' + _uid">{{ $t('person.middleName') }}</label>
                        <div class="ml-2"
                             :name="'surName' + _uid"
                             :id="'surName' + _uid">
                            {{model.person.middleName}}
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold" :for="'lastName' + _uid">
                            {{ $t('person.lastName')}}
                        </label>
                        <div class="ml-2"
                             :name="'lastName' + _uid"
                             :id="'lastName' + _uid">
                            {{model.person.lastName}}
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-sm-12 col-md-8">
                        <label class="font-weight-bold">{{ $t('person.identification') }}</label>
                        <div class="ml-2"
                             :name="'identificationType' + _uid"
                             :id="'identificationType' + _uid">
                            {{ model.person.personIdentification ? model.person.personIdentification.number : '' }}
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-4">
                        <label class="font-weight-bold">{{ $t('person.gender') }}</label>
                        <div class="ml-2"
                             :name="'gender' + _uid"
                             :id="'gender' + _uid">
                            {{ isEnVersion ? model.person.genderEn : model.person.gender }}
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group form-group col-sm-12 col-md-4">
                        <label class="font-weight-bold" :for="'idCardNumber' + _uid">{{ $t('person.idCardNumber') }}</label>
                        <div class="ml-2"
                             :name="'idCardNumber' + _uid"
                             :id="'idCardNumber' + _uid">
                            {{model.person.idCardNumber}}
                        </div>
                    </div>


                    <div class="form-group form-group col-sm-12 col-md-4">
                        <label class="font-weight-bold" :for="'idCardDateOfIssue' + _uid">{{ $t('person.idCardDateOfIssue') }}</label>
                        <div class="ml-2"
                             :name="'idCardDateOfIssue' + _uid"
                             :id="'idCardDateOfIssue' + _uid">
                            {{ model.person.idCardDateOfIssue ? moment(model.person.idCardDateOfIssue).format('DD.MMM.YYYY') : '' }}
                        </div>
                    </div>

                    <div class="form-group form-group col-sm-12 col-md-4">
                        <label class="font-weight-bold" :for="'idCardIssuedBy' + _uid">{{ $t('person.idCardIssuedBy') }}</label>
                        <div class="ml-2"
                             :name="'idCardIssuedBy' + _uid"
                             :id="'idCardIssuedBy' + _uid">
                            {{model.person.idCardIssuedBy}}
                        </div>

                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold" :for="'email' + _uid">{{ $t('email') }}</label>
                        <div class="ml-2"
                             :name="'email' + _uid"
                             :id="'email' + _uid">
                            {{model.person.email}}
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold" :for="'phone' + _uid">
                            {{ $t('person.phone') }}
                        </label>
                        <div class="ml-2"
                             :name="'phone' + _uid"
                             :id="'phone' + _uid">
                            {{model.person.phone}}
                        </div>

                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold" :for="'mobilePhone' + _uid">
                            {{ $t('person.mobilePhone')}}
                        </label>
                        <div class="ml-2"
                             :name="'mobilePhone' + _uid"
                             :id="'mobilePhone' + _uid">
                            {{model.person.mobilePhone}}
                        </div>

                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-12">
                        <label class="font-weight-bold">{{ $t('person.description') }}</label>
                        <div class="ml-2"
                             :name="'description' + _uid"
                             :id="'description' + _uid">
                            {{model.person.description}}
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold" :for="'institution' + _uid">
                            {{ $t('person.institution')}}
                        </label>
                        <div class="ml-2"
                             :name="'institution' + _uid"
                             :id="'institution' + _uid">
                            {{ isEnVersion ? model.person.institutionDetailsEn : model.person.institutionDetails }}
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold" :for="'institutionLocation' + _uid">
                            {{$t('person.institutionLocation')}}
                        </label>
                        <div class="ml-2"
                             :name="'institution' + _uid"
                             :id="'institution' + _uid">
                            {{ isEnVersion ? model.person.institutionLocationDetailsEn : model.person.institutionLocationDetails }}
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold required">{{ $t('person.positionStatistic') }}</label>
                        <div class="ml-2"
                             :name="'positionStatistic' + _uid"
                             :id="'positionStatistic' + _uid">
                            {{ isEnVersion ? model.person.positionStatisticDetailsEn : model.person.positionStatisticDetails }}
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold">{{ $t('person.position') }}</label>
                        <div class="ml-2"
                             :name="'position' + _uid"
                             :id="'position' + _uid">
                            {{ isEnVersion ? model.person.positionDetailsEn : model.person.positionDetails }}
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold" :for="'positionStr' + _uid">{{ $t('person.position') }}</label>
                        <div class="ml-2"
                             :name="'positionStr' + _uid"
                             :id="'positionStr' + _uid">
                            {{model.person.positionStr}}
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold">{{ $t('person.salutation') }}</label>
                        <div class="ml-2"
                             :name="'salutation' + _uid"
                             :id="'salutation' + _uid">
                            {{ isEnVersion ? model.person.salutationDetailsEn : model.person.salutationDetails }}
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold">{{ $t('person.titleDegree') }}</label>
                        <div class="ml-2"
                             :name="'titleDegree' + _uid"
                             :id="'titleDegree' + _uid">
                            {{ isEnVersion ? model.person.titleDegreeDetailsEn : model.person.titleDegreeDetails }}
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold">{{ $t('person.educationDegree') }}</label>
                        <div class="ml-2"
                             :name="'educationDegree' + _uid"
                             :id="'educationDegree' + _uid">
                            {{ isEnVersion ? model.person.educationDegreeDetailsEn : model.person.educationDegreeDetails }}
                        </div>
                    </div>
                </div>

                <BankAccountEditor :bankAccount="model.bankAccount"
                                   :required="false"
                                   :showDescription="false"
                                   :readonly="true"></BankAccountEditor>

                <hr />

                <div class="form-row">
                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold required" :for="'participationType' + _uid">{{$t("registers.events.participants.gridHeaders.participationType")}}</label>
                        <div class="ml-2"
                             :name="'participationType' + _uid"
                             :id="'participationType' + _uid">
                            {{ isEnVersion ? model.participationTypeNameEn : model.participationTypeName }}
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold" :for="'ralationType' + _uid">{{$t("registers.events.participants.gridHeaders.relationType")}}</label>
                        <div class="ml-2"
                             :name="'relationType' + _uid"
                             :id="'relationType' + _uid">
                            {{ isEnVersion ? model.relationTypeNameEn : model.relationTypeName }}
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold" :for="'reasonForAdmission' + _uid">{{$t("registers.events.participants.gridHeaders.reasonForAdmission")}}</label>
                        <div class="ml-2"
                             :name="'reasonForAdmission' + _uid"
                             :id="'reasonForAdmission' + _uid">
                            {{ isEnVersion ? model.reasonForAdmissionEn : model.reasonForAdmission}}
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold" :for="'participationStatus' + _uid">{{$t("registers.events.participants.gridHeaders.status")}}</label>
                        <div class="ml-2"
                             :name="'status' + _uid"
                             :id="'status' + _uid">
                            {{ isEnVersion ? model.statusEn : model.status}}
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'note' + _uid">{{ $t('registers.events.participants.gridHeaders.note') }}</label>
                        <div class="ml-2"
                             :name="'note' + _uid"
                             :id="'note' + _uid">
                            {{ model.note}}
                        </div>
                    </div>
                </div>

                <hr />

                <div class="row mt-md-2 mt-sm-1">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold" :for="'deployed' + _uid">
                            {{$t('reportData.participants.deployed')}}
                        </label>
                        <div class="ml-2"
                             :name="'deployed' + _uid"
                             :id="'deployed' + _uid">
                            {{model.deployed}}
                        </div>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold" :for="'cityOfCurrentAddress' + _uid">
                            {{$t('reportData.participants.cityOfCurrentAddress')}}
                        </label>
                        <div class="ml-2"
                             :name="'cityOfCurrentAddress' + _uid"
                             :id="'cityOfCurrentAddress' + _uid">
                            {{model.cityOfCurrentAddress}}
                        </div>
                    </div>
                    <div class="form-group col-sm-12 col-md-6  col-lg-4">
                        <label class="font-weight-bold" :for="'currentSettlement' + _uid">{{$t("reportData.participants.currentSettlement")}}</label>
                        <div class="ml-2"
                             :name="'currentSettlement' + _uid"
                             :id="'currentSettlement' + _uid">
                            {{ isEnVersion ? model.currentSettlementEn : model.currentSettlement}}
                        </div>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold" :for="'accommodationRequest' + _uid">
                            {{$t('reportData.participants.accommodationRequest')}}
                        </label>
                        <div class="ml-2"
                             :name="'accommodationRequest' + _uid"
                             :id="'accommodationRequest' + _uid">
                            {{model.accommodationRequest}}
                        </div>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold" :for="'datesForNights' + _uid">
                            {{$t('reportData.participants.datesForNights')}}
                        </label>
                        <div class="ml-2"
                             :name="'datesForNights' + _uid"
                             :id="'datesForNights' + _uid">
                            {{model.datesForNights}}
                        </div>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold" :for="'roomType' + _uid">
                            {{$t('reportData.participants.roomType')}}
                        </label>
                        <div class="ml-2"
                             :name="'roomType' + _uid"
                             :id="'roomType' + _uid">
                            {{model.roomType}}
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.vegetarianMenu"
                                     :name="'vegetarianMenu' + _uid"
                                     :id="'vegetarianMenu' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.vegetarianMenu') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.travelers"
                                     :name="'travelers' + _uid"
                                     :id="'travelers' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.travelers') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.consentToBeProcessed"
                                     :name="'consentToBeProcessed' + _uid"
                                     :id="'consentToBeProcessed' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.consentToBeProcessed') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6  col-lg-4">
                        <label class="font-weight-bold" :for="'employment' + _uid">{{$t("reportData.participants.employment")}}</label>
                        <div class="ml-2"
                             :name="'employment' + _uid"
                             :id="'employment' + _uid">
                            {{ isEnVersion ? model.employmentEn : model.employment}}
                        </div>
                    </div>

                </div>

                <hr />

                <div class="row mt-md-2 mt-sm-1">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.isMigrant"
                                     :name="'isMigrant' + _uid"
                                     :id="'isMigrant' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.isMigrant') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.isForeigner"
                                     :name="'isForeigner' + _uid"
                                     :id="'isForeigner' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.isForeigner') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.isMemberOfAMinority"
                                     :name="'isMemberOfAMinority' + _uid"
                                     :id="'isMemberOfAMinority' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.isMemberOfAMinority') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.isOfGypsyOrigin"
                                     :name="'isOfGypsyOrigin' + _uid"
                                     :id="'isOfGypsyOrigin' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.isOfGypsyOrigin') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.withDisabilities"
                                     :name="'withDisabilities' + _uid"
                                     :id="'withDisabilities' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.withDisabilities') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.isHomeless"
                                     :name="'isHomeless' + _uid"
                                     :id="'isHomeless' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.isHomeless') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.isDisadvantaged"
                                     :name="'isDisadvantaged' + _uid"
                                     :id="'isDisadvantaged' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.isDisadvantaged') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.isFromUnemployedHousehold"
                                     :name="'isFromUnemployedHousehold' + _uid"
                                     :id="'isFromUnemployedHousehold' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.isFromUnemployedHousehold') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.withDependentChildren"
                                     :name="'withDependentChildren' + _uid"
                                     :id="'withDependentChildren' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.withDependentChildren') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.fromOneMemberHousehold"
                                     :name="'fromOneMemberHousehold' + _uid"
                                     :id="'fromOneMemberHousehold' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.fromOneMemberHousehold') }}
                        </vs-checkbox>
                    </div>
                </div>


                <div v-if="files" class="form-group col-12 p-0">
                    <div v-for="(file,index) in files"
                         class="mt-2 border border-light-2 p-2">
                        <div class="col-12 align-items-center k-display-flex">
                            <file-download :file="file"
                                          :showDescription="true"
                                          class="col-12"
                                          :type="file.docTypeCode">
                            </file-download>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mt-3">
            <div class="card-header bg-primary text-white">
                <div class="card-title h5 m-0">{{ $t('eventDocuments.title') }}</div>
            </div>
            <div v-if="showEventDocs">
                <participant-event-docs ref="participantEventDocs" :participantId="Number(this.value.id)"></participant-event-docs>
            </div>
        </div>

        <div class="card-footer text-muted" v-if="model.person.relatedUsername">
            {{ $t('person.relatedToUser') + '"' + model.relatedUsername + '"' }}
        </div>
    </div>
</template>

<script>
    import { Participant } from '@/models/models';
    import ParticipationEventDocs from '../../components/docs/ParticipationEventDocs';
    import BankAccountEditor from '../../components/bankAccount/BankAccountEditor';
    import FileDownload from "@/components/common/FileDownload";

    import moment from 'moment';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            'participant-event-docs': ParticipationEventDocs,
            BankAccountEditor,
            FileDownload,
        },
        props: {
            value: {
                type: [Participant, Object],
                required: false
            },
            files: {
                type: Array,
                default: undefined
            }
        },
        data() {
            return {
                model: this.value,
                moment: moment,
                showEventDocs: true
            }
        },
        methods: {
            onCancel(e) {
                this.$emit("cancel", e);
            }
        },
        computed: {
            ...mapGetters(['isEnVersion']),
            fullName() {
                let name = this.model.person.firstName;
                if (this.model.person.middleName) {
                    name += ` ${this.model.person.middleName}`
                }

                if (this.model.person.lastName) {
                    name += ` ${this.model.person.lastName}`
                }

                return name;
            }
        },
        mounted() {
        },
        watch: {
            value: function (val) {
                if (val) {
                    this.model = new Participant(this.value);
                }
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
